<template>
  <div class="login-main">
    <div class="login-title">
      <span class="logo-icon">
        <img src="../../assets/image/yuantu.png" >
       
        <!-- {{lan.c_cochat}} -->
      </span>
      <span class="language" @click="changeEn" v-show="lanType">English</span>
      <span class="language" @click="changeCn" v-show="!lanType">中文</span>
    </div>
    <div class="login-center">
      <img src="../../assets/image/login-icon.png" class="icon" v-show="common.language == 'cn'"/>
       <img src="../../assets/image/loginen.png" v-show="common.language == 'en'" class="icon">
      <div class="login-input">
        <span class="login-name">{{lan.c_login}}</span>
        <img src="../../assets/image/addressbook.png" class="input-icon" />
        <input type="text" :placeholder="lan.PleaseUser" @input="input_user" v-model="user" @blur="check"/>
        <img src="../../assets/image/unlock.png" class="input-icon" />
        <input :type="open? 'password': 'text'" :placeholder="lan.PleasePwd" @input="input_password" v-model="login.pwd" />
        <img src="../../assets/image/hudun.png" class=" hudun" />
        <img src="../../assets/image/open.png" class="eye" v-show="!open" @click="isOpen">
        <img src="../../assets/image/close.png" class="eye" v-show="open"  @click="isOpen">
        <input
          type="text"
          class="otp"
          :placeholder="lan.PleaseOtp"
          @input="input_otp"
          v-model="otp"
          @keyup.enter="log_in"
          v-show="login.ADuser == 'ad'"
        />
        <span class="login-tips">
          {{lan.adDesc}} {{lan.Lrzgw}}
          <a href="https://otp.lenovo.com">https://otp.lenovo.com</a>
        </span>
        <button class="login-btn" @click="log_in">{{lan.c_login}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import Login from "../../api/login";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import router from "../../router/index";
import AES from '../../assets/commonjs/aes'
export default {
  data() {
    return {
      pwd: "",
      otp: "",
      user: "",
      lanType: true,
      open:true
    };
  },
  computed: {
    ...mapState(["login", "rong",'common']),
    ...mapGetters({
      personalList: "rong/personalList",
      groupList: "rong/groupList",
      lan: "common/lan"
    })
  },
  methods: {
    ...mapMutations({
      get_userInfo: "login/get_userInfo",
      getUrl: "headurl/getUrl",
      getSingleHeadUrl: "rong/getSingleHeadUrl",
      getGroupHeadUrl: "rong/getGroupHeadUrl",
      setlanguage: "common/setlanguage",
      checkUser:'login/checkUser'
    }),

    check(e){
      if(e.target.value){
        this.checkUser(e.target.value)
      }
    },

    log_in() {

      this.get_userInfo();
      
      // this.getUrl(this.user);
      // console.log(this.login.userInfo.itcode)
      // console.log(this.user)
      this.rong.nomessage = true;
    },
    input_password() {
      // console.log(this)
      this.login.info.pwd = this.login.pwd;
      // console.log(this.login.info.pwd,this.login.pwd)
    },
    input_user() {
      this.login.info.user = this.user;
      // console.log(this.login.info.user)
    },
    input_otp() {
      this.login.info.OTP = this.otp;
    },
    changeEn() {
      this.lanType = false;
      this.setlanguage("en");
    },
    changeCn() {
      this.lanType = true;
      this.setlanguage("cn");
    },
    isOpen(){
      this.open= !this.open
    }
  },
  mounted(){
    this.login.pwd = ''
  }
};
</script>
<style lang="scss" scoped src='./login.scss'>
</style>






// WEBPACK FOOTER //
// src/components/login/index.vue